var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgEducation = function SvgEducation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168.72 168.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.29,91.54V108.7a12.27,12.27,0,0,0,6.35,10.74l30.52,16.67a12.16,12.16,0,0,0,11.73,0l30.52-16.67a12.27,12.27,0,0,0,6.35-10.74V91.54L86.89,111.69a12.16,12.16,0,0,1-11.73,0Zm36.87-59L23.7,60.65a6.14,6.14,0,0,0,0,10.74L75.16,99.48a12.16,12.16,0,0,0,11.73,0L136,72.68v36.08a6.11,6.11,0,0,0,12.21,0V69.62A6.14,6.14,0,0,0,145,64.25L86.89,32.57A12.44,12.44,0,0,0,75.16,32.57Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEducation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/education.7ed708ef.svg";
export { ForwardRef as ReactComponent };